
<div class="wrapper">
    <h1 class="font-title">{{'header.aboutUs' | translate}}</h1>
    <youtube-player videoId="LqDsFo1vncU" suggestedQuality="highres"  [height]="400" [width]="800" >
    </youtube-player>
</div>
